import axios from 'axios';

import functions from '../functions/functions';

import variables from '../variables';

const postContent = {};

postContent.class = '.post-content';

postContent.init = () => {
  postContent.shortCodesInit();
  postContent.pruneEmptyParagraphs();
  postContent.getPosts();
};

postContent.pruneEmptyParagraphs = () => {
  let e; let i = 0; let j = 0; let len;
  const paragraphs = document.querySelectorAll(`${postContent.class} p`);
  if (paragraphs.length) {
    for (i = 0, len = paragraphs.length; j < len; i = ++j) {
      e = paragraphs[i];
      e.innerHTML = postContent.pruneEmpty(e.innerHTML);
    }
  }
};

postContent.pruneEmpty = (string) => {
  if (functions.stripHtmlComments(string.trim())) {
    if (functions.stripHtmlComments(string.trim()) === '' || functions.stripHtmlComments(string.trim()) === '<br>') {
      return '';
    }
  }
  return string;
};

postContent.getPostFromApi = (element) => {
  let pathToPost; let post_type; let thisElement; let
    thisPostId;
  if (element.innerHTML !== undefined && element.innerHTML.trim().length === 0) {
    thisPostId = functions.slugify(`p${functions.makeid()}`);
    element.setAttribute('id', thisPostId);
    thisElement = document.getElementById(thisPostId);
    if (thisElement.dataset.hasOwnProperty('post_name')) {
      post_type = thisElement.dataset.hasOwnProperty('post_type') ? thisElement.dataset.post_type : 'posts';
      thisElement.innerHTML = variables.loading;
      pathToPost = `${variables.wpApiPath + post_type}/?slug=${thisElement.dataset.post_name}`;
      return axios.get(`${variables.wpApiPath + post_type}/?slug=${thisElement.dataset.post_name}`).then((response) => {
        thisElement.innerHTML = response.data[0].content.rendered;
        postContent.pruneEmptyParagraphs();
        const newPosts = document.querySelectorAll(`#${thisPostId} .get-post`);
        if (newPosts.length) {
          Object.keys(newPosts).forEach((k) => {
            postContent.getPostFromApi(newPosts[k]);
          });
        }
      }).catch((error) => {
        thisElement.innerHTML = variables.loadingError;
        if (variables.env !== 'production') {
          thisElement.innerHTML = `${thisElement.innerHTML}<!-- ${error}  --><p class="loading-error"><span class="loading-error-text">Could not get the post "${thisElement.dataset.post_name}" in post type "${post_type}"<br>${pathToPost}</span></p>`;
        }
      });
    }
  }
  return null;
};

postContent.getPosts = () => {
  let results;
  const posts = document.querySelectorAll('.get-post');
  if (posts.length) {
    results = [];
    Object.keys(posts).forEach((k) => {
      results.push(postContent.getPostFromApi(posts[k]));
    });
    return results;
  }
  return null;
};

postContent.shortCodesInit = () => {};

export default postContent;
